<!-- 确认组件 -->
<template>
  <div>
    <div class="chat-card">
      <div class="chat-text" v-if="cardData.text">
        {{ cardData.text }}
      </div>
      <div class="all-btn" v-if="isCanEdit">
        <div class="item-btn" @click="submitFn(true, cardData.confirmTxt)">
          {{ cardData.confirmTxt || '准备好了' }}
        </div>
        <div class="item-btn" @click="submitFn(false, cardData.cancelTxt)">
          {{ cardData.cancelTxt || '没准备好' }}
        </div>
      </div>
    </div>
    <!-- <div v-if="cardData.isShowTime" class="send-time">09月01日  16:29</div> -->
  </div>
</template>

<script>
export default {
  name: 'ChatConfirm',
  components: {},
  props: {
    cardData: {
      type: Object,
      default: () => {
        return null;
      },
    },
    // 是否可编辑
    isCanEdit: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    submitFn(isBoolean, text) {
      //提交是否愿意治疗
      const useData = {
        id: this.cardData.id,
        step_id: this.cardData.step_id,
        step_data: {
          current: { try_treatment_confirm_result: isBoolean },
        },
      };
      this.$emit('sendMsg', {
        sendData: {
          type: 'ChatSend',
          text
        },
        submitData: useData
      });
      // this.$emit('confirmFn', useData);
    },
  },
};
</script>

<style scoped lang="scss">
.chat-card {
  width: 342px;
  border-radius: 12px 12px 12px 0px;
  padding: 10px 24px 10px 12px;
  background: #e8e3fc;
  box-sizing: border-box;
  .chat-text {
    color: $text-color;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 23px;
  }
  .all-btn {
    display: flex;
    align-items: center;
    margin-top: 16px;
    .item-btn {
      height: 27px;
      border-radius: 70px;
      background: #ffffff;
      padding: 0 20px;
      display: flex;
      align-items: center;
      font-size: 10px;
      font-weight: 500;
      letter-spacing: 0px;
      color: $text-color;
      margin-right: 10px;
    }
  }
}
.send-time {
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 20px;
  color: #9d9fa3;
  margin-top: 4px;
}
</style>
